var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, props),
    React.createElement(
      "title",
      null,
      "usa"
    ),
    React.createElement(
      "g",
      { className: styles["nc-icon-wrapper"] || "nc-icon-wrapper" },
      React.createElement("path", { fill: "#B41F30", d: "M48 8a2 2 0 0 0-2-2H20v20H0v14a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V8z" }),
      React.createElement("path", { fill: "#E6E6E6", d: "M20 10h28v4H20zM20 18h28v4H20zM0 26v4h48v-4H20zM0 34h48v4H0z" }),
      React.createElement("path", { fill: "#00256A", d: "M20 26H0V8a2 2 0 0 1 2-2h18v20z" }),
      React.createElement("path", { fill: "#FFF", d: "M10 13.922l-.633 1.368H7.863l1.1 1.14-.406 1.648L10 17.26l1.443.818-.406-1.648 1.1-1.14h-1.506zM5.107 9.029l-.632 1.368H2.971l1.099 1.14-.406 1.648 1.443-.818 1.444.818-.407-1.648 1.1-1.14H5.738zM14.893 9.029l.632 1.368h1.504l-1.099 1.14.406 1.648-1.443-.818-1.444.818.407-1.648-1.1-1.14h1.506zM5.107 22.971l-.632-1.368H2.971l1.099-1.14-.406-1.648 1.443.818 1.444-.818-.407 1.648 1.1 1.14H5.738zM14.893 22.971l.632-1.368h1.504l-1.099-1.14.406-1.648-1.443.818-1.444-.818.407 1.648-1.1 1.14h1.506z" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/us-flag.svg